import { findBoundaryTime } from "utils/datesAndTimes/findBoundaryTime";

export function findLatestTime(
	dates: Date[],
	midnightIsLate: boolean
): moment.Duration | undefined {
	return findBoundaryTime(dates, midnightIsLate, false);
}
